function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEccf = function SvgEccf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607D8B"
    },
    d: "M34,37c0,0-2.214-4-8-4s-8,4-8,4v2h16V37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9800"
    },
    d: "M28.015,30h-4v3c0,0-0.124,2,1.959,2s2.041-2,2.041-2V30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB74D"
    },
    d: "M26.014,32c-2.758,0-5-2.242-5-5c0-2.758,2.242-5,5-5s5,2.242,5,5C31.014,29.758,28.771,32,26.014,32"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242"
    },
    d: "M25.795,20c-2.438,0.219-4.781,1.93-4.781,5.574V27l1,1v-3l6.31-2.201L30.014,25v3l1-1v-1.203c0-2.414-0.135-4.205-3-4.797l-0.485-1H25.795z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2196F3"
    },
    points: "3.014,29.061 9.279,33.561 9.279,33.561 10.324,34.311 10.324,34.311 15.573,27"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2196F3"
    },
    d: "M39.448,13.564c-7.419-7.42-19.45-7.42-26.87,0C7.843,18.299,6.148,24.908,7.462,31h4.117c-1.394-5.035-0.13-10.648,3.828-14.605c5.857-5.859,15.355-5.859,21.213,0c4.599,4.598,5.57,11.436,2.947,16.998l3.516,1.918C46.531,28.227,45.332,19.449,39.448,13.564z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEccf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eccf.dfbc8d69.svg";
export { ForwardRef as ReactComponent };